import { useState } from 'react';
import { JournalEntry } from "./JournalEntry";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
interface JournalEntryListProps {
  entries: Array<{
    id: number;
    created_at: string;
    content: string;
    mood_rating: string;
    mood_tags?: string[];
    ai_verse?: string;
    ai_prayer?: string;
  }>;
}
export function JournalEntryList({
  entries
}: JournalEntryListProps) {
  const [displayCount, setDisplayCount] = useState(5);
  if (entries.length === 0) {
    return <div className="text-center py-6 text-gray-500 text-sm">
        No journal entries yet. Start writing to begin your journey.
      </div>;
  }
  const displayedEntries = entries.slice(0, displayCount);
  const hasMore = entries.length > displayCount;
  const loadMore = () => {
    setDisplayCount(prev => prev + 10);
  };
  return <div className="space-y-2">
      {displayedEntries.map(entry => <JournalEntry key={entry.id} entry={entry} />)}
      
      {hasMore && <div className="pt-3 text-center">
          <Button onClick={loadMore} variant="outline" size="sm" className="w-full max-w-[180px] flex items-center justify-center gap-1.5 text-xs py-1 h-auto text-gray-950">
            Show More <ChevronDown className="h-3 w-3" />
          </Button>
        </div>}
    </div>;
}